export const normalizeProductTags = (tags) => {
    const filtered = tags?.filter(e => !!e?.id && !!(e?.name ?? '').trim()) ?? [];
    const uniqueIds = [...new Set(filtered.map(e => e.id))];
    return uniqueIds.map(id => filtered.find(t => t.id === id)).filter(Boolean);
};

export const getProductTagsKey = (tags) => (
    normalizeProductTags(tags)
        .map(tag => `${tag.id}:${tag.iconFileName ?? tag.iconInfo?.url ?? ''}:${tag.name ?? ''}`)
        .join('|')
);

export const getTagIconFileName = (tag) => tag?.iconFileName ?? tag?.iconInfo?.url;
